var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackCalendarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 2.49999H14.8334V1.66666C14.8334 1.20833 14.4584 0.833328 14 0.833328C13.5417 0.833328 13.1667 1.20833 13.1667 1.66666V2.49999H4.83335V1.66666C4.83335 1.20833 4.45835 0.833328 4.00002 0.833328C3.54169 0.833328 3.16669 1.20833 3.16669 1.66666V2.49999H2.33335C1.41669 2.49999 0.666687 3.24999 0.666687 4.16666V17.5C0.666687 18.4167 1.41669 19.1667 2.33335 19.1667H15.6667C16.5834 19.1667 17.3334 18.4167 17.3334 17.5V4.16666C17.3334 3.24999 16.5834 2.49999 15.6667 2.49999ZM14.8334 17.5H3.16669C2.70835 17.5 2.33335 17.125 2.33335 16.6667V6.66666H15.6667V16.6667C15.6667 17.125 15.2917 17.5 14.8334 17.5Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCalendarIcon);
export default __webpack_public_path__ + "static/media/black-calendar-icon.278728697bd7a0f087bbdff00d02105e.svg";
export { ForwardRef as ReactComponent };